
import '../polyfills/fetch';

export default class AjaxForm 
{
	
	constructor(form) 
	{
		const _this = this;
		this.form = form;
		
		const domId = form.getAttribute('id');
		document.addEventListener('submit', function (event) {
			if (event.target.matches(`#${domId}`)) {
				event.preventDefault();
				_this.submit();
			}
		}, false);
		
		
		if ('vibrate' in navigator) {
			document.addEventListener('click', (event) => {
				if (event.target.matches(`#${domId} [type=submit]`) && form.checkValidity()) {	
					navigator.vibrate(50);
				}
			}, false);
		}
	}
	
	
	beforeSubmit() 
	{
		this.form.classList.add('is-loading');
		const event = new Event('beforeSubmit');
		this.form.dispatchEvent(event);
	}
	
	
	submit() 
	{
		this.beforeSubmit();
		
		const _this = this;
		const data = new FormData(this.form);
		const url = this.form.getAttribute('action');
		const csrf = document.querySelector("meta[name='csrf-token']");
		
		const options = {
			method: 'POST',
			body: data,
			headers: new Headers(),
		};
		
		options.headers.append('X-Requested-With', 'XMLHttpRequest'); // tell server this is an ajax request
		if( csrf ) {
			options.headers.append('X-CSRF-Token', csrf.getAttribute('content'));
		}
		
		fetch(url, options)
			.then(response => response.json())
			.then(json => {
				_this.submitResponse(json);
			});
	}
	
	
	submitResponse(response) 
	{
		//const r = JSON.parse(response);
		const message = this.buildMessage(response);
		this.form.insertAdjacentElement('beforebegin', message);
		
		const downloads = this.buildDownloads(response);
		if( downloads !== null ) {
			this.form.insertAdjacentElement('beforebegin', downloads);	
		}
		
		this.form.classList.remove('is-loading');
		
		let event;
		if( response.success ) {
			event = new Event('success');
			this.form.dispatchEvent(event);
			this.form.parentNode.removeChild(this.form);
		}
		else {
			event = new Event('fail');
			this.form.dispatchEvent(event);
		}
	}
	
	
	buildMessage(response) {
		const txt = document.createTextNode(response.message);
		const msg = document.createElement('div');
		msg.appendChild(txt);
		msg.classList.add('message', 'flash-message', (response.success ? 'success' : 'error') );
		return msg;
	}
	
	buildDownloads(response) {
		if(! response.hasOwnProperty('downloads') ) {
			return null;
		}
		const holder = document.createElement('div');
		holder.innerHTML = response.downloads;
		return holder;
	}	
}